module.exports = __webpack_public_path__ + "static/media/girl4.e1a79c1c.jpg";